// i18n.js — Matrix v2 viacjazyčné UI  (ústava sek. 6)
// ════════════════════════════════════════════════════════════════════
// STR[lang] = slovník kľúčov. `sk` = ZDROJOVÝ / kanonický jazyk.
// Ďalšie jazyky (uk/sq/pl…) — preklad zo `sk`.
//
// NOVÝ JAZYK ON-DEMAND (ústava 6): ak zamestnanec má `language_code`, ktorý
// nie je v STR → jazyk sa musí implementovať OKAMŽITE (AI preklad celého
// STR['sk'] cez Claude). Auto-generátor = ROADMAP; dovtedy manuálne.
//
// PRAVIDLO: 0 hardcoded textov — KAŽDÝ viditeľný text ide cez t('kľúč').
// Chýbajúci kľúč sa zobrazí ako samotný kľúč (nech je hneď vidno).

import { useMemo, useState, useEffect } from 'react'
import { useAuth } from './auth/AuthContext.jsx'

const FALLBACK = 'sk'

// ── Slovníky ─────────────────────────────────────────────────────────
export const STR = {
  sk: {
    'dennik.flat': 'Byt',
    'dennik.rozsah': 'Rozsah zápisu',
    'dennik.rozsah.stavba': 'K stavbe',
    'dennik.rozsah.byt': 'K bytu',
    'dennik.rozsah.stavba_hint': 'Celá stavba, objekt alebo poschodie — bez bytu.',
    'dennik.rozsah.byt_hint': 'Jeden konkrétny byt. Na ďalší byt sa robí samostatný zápis.',
    'dennik.byt_ph': 'Číslo bytu — napr. B3.12',
    'dennik.err.byt': 'Zadaj číslo bytu — zápis k bytu sa bez neho neuloží.',
    'dennik.miestnost': 'Miestnosť',
    'dennik.miestnost_opt': 'Miestnosť (nepovinné)',
    'dennik.floor_ine': 'Iné…',
    'dennik.floor_ine_ph': 'Vlastný popis…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Omietky',
    'preset.g.potery': 'Potery',
    'preset.g.malby': 'Maľby',
    'preset.g.kontrola': 'Kontrola omietkára',
    'preset.g.pripravenost': 'Pripravenosť stavby',
    'preset.om.1': 'Príprava podkladu',
    'preset.om.2': 'Inštalácia ochranných fólií a pások',
    'preset.om.3': 'Aplikácia sadrovej omietky stien',
    'preset.om.4': 'Aplikácia sadrovej omietky stropov',
    'preset.om.5': 'Aplikácia vápenno-cementovej omietky stien',
    'preset.om.6': 'Aplikácia vápenno-cementovej omietky stropov',
    'preset.om.7': 'Aplikácia penetrácie',
    'preset.om.8': 'Inštalácia rohových profilov',
    'preset.om.9': 'Inštalácia okenných APU profilov',
    'preset.om.10': 'Montáž lešenia',
    'preset.om.11': 'Demontáž lešenia',
    'preset.om.12': 'Upratovanie',
    'preset.om.13': 'Odstránenie fólií a pások',
    'preset.po.1': 'Príprava podkladu (brúsenie, vysávanie)',
    'preset.po.2': 'Penetrácia podkladu',
    'preset.po.3': 'Lepenie obvodovej pásky',
    'preset.po.4': 'Pokládka PE/separačnej fólie',
    'preset.po.5': 'Pokládka rámovej dilatácie',
    'preset.po.6': 'Aplikácia cementového poteru',
    'preset.po.7': 'Aplikácia anhydritu (MIXFLOOR)',
    'preset.po.8': 'Vyrovnanie laserom',
    'preset.po.9': 'Brúsenie poteru',
    'preset.po.10': 'Rezanie dilatačných škár',
    'preset.ma.1': 'Olepovanie (pásky, fólie)',
    'preset.ma.2': 'Príprava podkladu',
    'preset.ma.3': 'Penetrácia + maľba (1. vrstva)',
    'preset.ma.4': 'Vrchný náter (2. náter)',
    'preset.ma.5': 'Tónovaná maľba (RAL)',
    'preset.ma.6': 'Opravy omietok',
    'preset.ma.7': 'Brúsenie opráv',
    'preset.ma.8': 'Odovzdanie prác',
    'preset.ko.1': 'bez závad',
    'preset.ko.2': 'zlý finiš špaleta',
    'preset.ko.3': 'pravý uhol mimo normu',
    'preset.ko.4': 'rovinatosť stien mimo normu',
    'preset.ko.5': 'zlá rovinatosť soklov',
    'preset.ko.6': 'zlý finiš stien',
    'preset.ko.7': 'zlý finiš stropov',
    'preset.ko.8': 'zaomietané zásuvky',
    'preset.ko.9': 'neočistené káble',
    'preset.ko.10': 'neočistené okná',
    'preset.ko.11': 'neupratané',
    'preset.pr.1': 'neosadené okná',
    'preset.pr.2': 'nedokončená ZTI',
    'preset.pr.3': 'nedokončená ELI',
    'preset.pr.4': 'chýbajú pásky okien',
    'preset.pr.5': 'neorezaná pena',
    'preset.pr.6': 'neprilepené káble stropov',
    'preset.pr.7': 'rovinatosť stien mimo normu',
    'preset.pr.8': 'pravé uhly mimo normu',
    // spoločné
    'common.save':     'Uložiť',
    'common.cancel':   'Zrušiť',
    'common.back':     'Späť',
    'common.search':   'Hľadať',
    'common.add':      'Pridať',
    'common.delete':   'Zmazať',
    'common.edit':     'Upraviť',
    'common.yes':      'Áno',
    'common.no':       'Nie',
    'common.loading':  'Načítavam…',
    'common.done':     'Hotovo',
    'common.confirm':  'Potvrdiť',
    'common.close':    'Zavrieť',
    'common.required': 'povinné',
    'common.saved':    'Uložené',
    'common.error':    'Chyba',
    'common.retry':    'Skúsiť znova',
    // mobilný shell — záložky
    'mobile.tab.dennik':    'Denník',
    'mobile.tab.blocky':    'Bločky',
    'mobile.tab.vymery':    'Výmery',
    'mobile.tab.vozidla':   'Vozidlá',
    'mobile.tab.pozicovna': 'Požičovňa',
    'mobile.tab.dochadzka': 'Dochádzka',
    // mview_appka_v1 (17. 10. 2026): obrazovka Dnes, Pokládka po bytoch, zámok do príchodu (Mirko 1516/1426/1506)
    'mobile.tab.dnes':      'Dnes',
    'mobile.tab.pokladka':  'Pokládka',
    'mobile.tab.ja':        'Ja',
    'mobile.ja.meno': 'Meno',
    'mobile.ja.jazyk': 'Jazyk',
    'mobile.ja.z_karty': 'z karty',
    'mobile.ja.fronta': 'Čaká na odoslanie',
    'mobile.ja.tyzden': 'Tento týždeň',
    'mobile.ja.tyzden_prazdny': 'Tento týždeň ešte nemáš zapísaný príchod.',
    'mobile.dnes.pozdrav': 'Dobrý deň',
    'mobile.dnes.kde_robis': 'Zákazka, kde dnes robíš',
    'mobile.dnes.ina': 'Iná…',
    'mobile.dnes.z_rozpisu': 'Zoznam je z Rozpisu prác. Iná stavba: ťukni „Iná…“.',
    'mobile.dnes.vsetky': 'Všetky zákazky.',
    'mobile.dnes.ziadne_zakazky': 'Nenašla sa žiadna zákazka — povedz office.',
    'mobile.dnes.prichod': 'PRÍCHOD',
    'mobile.dnes.odchod': 'ODCHOD',
    'mobile.dnes.ukladam': 'Ukladám…',
    'mobile.dnes.gps_hint': 'Poloha sa uloží raz pri príchode a raz pri odchode. Bez signálu sa pošle neskôr.',
    'mobile.dnes.dnes_uz': 'Dnes už máš odpracované {h} h.',
    'mobile.dnes.si_na_stavbe': 'Si na stavbe',
    'mobile.dnes.min_max': 'min {min}° / max {max}°',
    'mobile.dnes.pocasie_nacitavam': 'Počasie sa načítava…',
    'mobile.dnes.pocasie_bez_adresy': 'Počasie nie je — zákazka nemá adresu.',
    'mobile.dnes.pocasie_hint': 'Počasie podľa adresy zákazky, zapisuje sa do denníka samo.',
    'mobile.dnes.s_tebou': 'Dnes s tebou',
    'mobile.dnes.ludia_na_stavbe': 'ľudia na stavbe',
    'mobile.dnes.odpracovane': 'odpracované',
    'mobile.dnes.otvorit_dennik': 'Otvoriť denník dňa',
    'mobile.dnes.zmena_stavby': 'Zmena stavby',
    'mobile.dnes.zmena_stavby_hint': 'Zmena stavby uzavrie úsek a začne nový',
    'mobile.dnes.odchod_hint': 'Po odchode sa dá znova prísť. Časy opravuje len office.',
    'mobile.dnes.hotovo': 'Hotovo za dnes',
    'mobile.dnes.useky': 'Úseky dňa',
    'mobile.dnes.prisiel_znova': 'Prišiel som znova',
    'mobile.dnes.prichod_ok': 'Príchod {cas} · poloha uložená',
    'mobile.dnes.odchod_ok': 'Odchod {cas} · poloha uložená',
    'mobile.dnes.bez_gps': 'bez polohy',
    'mobile.dnes.offline_ulozene': 'Bez signálu — uložené v telefóne, pošle sa samo.',
    'mobile.dnes.fronta': 'čaká na odoslanie: {n}',
    'mobile.dnes.bez_zamestnanca': 'Konto nemá priradeného zamestnanca — povedz office.',
    'mobile.dnes.vyber_zakazku': 'Vyber zákazku',
    'mobile.zamok.nadpis': 'Najprv Príchod',
    'mobile.zamok.text': 'Denník dňa sa odomkne, keď si na stavbe urobíš príchod v dochádzke.',
    'mobile.zamok.tlacidlo': 'Ísť na Príchod',
    'mobile.pokladka.nadpis': 'Pokládka po bytoch',
    'mobile.pokladka.pokyn': 'Ťukni byt, kde je pokládka hotová. Office to potvrdí.',
    'mobile.pokladka.byt': 'Byt',
    'mobile.pokladka.miestnost1': '{n} miestnosť',
    'mobile.pokladka.miestnosti24': '{n} miestnosti',
    'mobile.pokladka.miestnosti': '{n} miestností',
    'mobile.pokladka.pokladka': 'pokládka',
    'mobile.pokladka.navrh': 'návrh poslaný',
    'mobile.pokladka.potvrdene': 'potvrdené office',
    'mobile.pokladka.navrh_poslany': 'Byt {byt} · pokládka hotová, {miest} (návrh)',
    'mobile.pokladka.navrh_zruseny': 'Návrh zrušený',
    'mobile.pokladka.uz_potvrdene': 'Už potvrdené office, zmeniť môže len kancelária.',
    'mobile.pokladka.preskocene': '{n} miestností sa nedalo označiť (už potvrdené).',
    'mobile.pokladka.bez_bytov': 'Táto zákazka nemá vo Výmerách poterové byty.',
    'mobile.pokladka.offline': 'Bez signálu — zoznam bytov sa nenačítal.',
    'mobile.pokladka.legenda': 'Jeden ťuk = celý byt, všetky miestnosti. Vrstvy: predvolené 2, zmeň len keď je inak. Oranžová = návrh · zelená = office potvrdil.',
    'mobile.pokladka.vrstvy': 'vrstvy',
    'mobile.pokladka.vrstvy_slovo': 'vrstvy',
    'mobile.tab.asistent':  'Asistent',
    'mobile.tab.uzivatelia': 'Používatelia',
    'mobile.logout':        'Odhlásiť',
    'mobile.module_soon':   'Modul sa pripravuje.',
    // denník
    'dennik.new':              'Nový zápis',
    'dennik.empty':            'Zatiaľ žiadny zápis.',
    'dennik.daily':            'Denný zápis',
    'dennik.control':          'Kontrolný zápis',
    'dennik.project':          'Zákazka',
    'dennik.date':             'Dátum',
    'dennik.ctype':            'Typ kontroly',
    'dennik.weather':          'Počasie',
    'dennik.workers':          'Počet pracovníkov',
    'dennik.work':             'Popis prác',
    'dennik.work_ph':          'Čo sa dnes robilo…',
    'dennik.stoppage':         'Prestoje',
    'dennik.stoppage_h':       'Hodiny prestoja',
    'dennik.koniec_etapy':     'KONČÍM ETAPU — ŽIADAM VÝPLATU',
    'dennik.poter.title':        'Poter (ak relevantné)',
    'dennik.poter.material':     'Druh materiálu',
    'dennik.poter.none':         '— neuviesť —',
    'dennik.poter.m2':           'Výmera (m²)',
    'dennik.poter.m2_ph':        'napr. 85,5',
    'dennik.poter.thickness':    'Hrúbka (mm)',
    'dennik.poter.spotreba': 'Spotreba materiálu',
    'dennik.poter.spotreba_ph': 'napr. 45 kg/m²',
    'dennik.poter.price': 'Cena (zadá office)',
    'dennik.poter.price_ph': '€ / m²',
    'dennik.poter.note': 'Poznámka',
    'dennik.poter.note_ph': 'napr. dilatácie, prídavky…',
    'dennik.poter.thickness_ph': 'napr. 60',
    'dennik.save_first':       'Uložiť zápis',
    'dennik.photos':           'Foto',
    'dennik.photo_after_save': 'Foto sa dá pridať po uložení zápisu.',
    'dennik.add_photo':        'Pridať foto',
    'dennik.photo_ok':         'Foto nahraté',
    'dennik.photo_err':        'Foto sa nenahralo — skús znova',
    'dennik.err.project':      'Vyber zákazku.',
    'dennik.err.desc':         'Vyplň popis prác.',
    'dennik.type.denny':       'Denný',
    'dennik.type.prvy':        'Prvý',
    'dennik.type.kontrolny':   'Kontrolný',
    'dennik.type.posledny':    'Posledný',
    'dennik.type.priebezny':   'Priebežný (starý)',
    'dennik.weather.sucho':    'Sucho',
    'dennik.weather.zamracene':'Zamračené',
    'dennik.weather.dazd':     'Dážď',
    'dennik.weather.sneh':     'Sneh',
    'dennik.weather.vietor':   'Vietor',
    'dennik.weather.mraz':     'Mráz',
    'dennik.sreason.nepripravenost': 'Nepripravenosť',
    'dennik.sreason.tech_porucha':   'Tech. porucha',
    'dennik.sreason.no_material':    'Nie je materiál',
    'dennik.sreason.teplota':        'Nevhodná teplota',
    'dennik.sreason.neporiadok':     'Neporiadok',
    'dennik.sreason.vlastny':        'Vlastný',
    'dennik.temp':            'Teplota',
    'dennik.temp_load':       'Načítať',
    'dennik.temp_ok':         'Teplota načítaná',
    'dennik.temp_fail':       'Počasie sa nenačítalo',
    'dennik.temp_no_addr':    'Zákazka nemá adresu — teplotu zadaj ručne',
    'dennik.findings':        'Druh kontroly / zistenia',
    'dennik.object':          'Objekt',
    'dennik.floor':           'Poschodie',
    'dennik.room':            'Byt / miestnosť',
    'dennik.add_block':       'Pridať popis',
    'dennik.stoppage_by':     'Kto zavinil prestoj',
    'dennik.opatrenie':       'Uložené opatrenie',
    'dennik.opatr_co':        'Čo treba spraviť',
    'dennik.opatr_kto':       'Zodpovedný',
    'dennik.handover':        'Prevzatie / odovzdanie',
    'dennik.taken':           'Prevzaté od zhotoviteľa',
    'dennik.given':           'Odovzdané zhotoviteľovi',
    'dennik.mark_done':       'Označiť miestnosť hotové',
    'dennik.done_mark':       'Hotové',
    // FIRMA/RD segment zákazky (ústava 23 + 25.1)
    'dennik.segment':        'Segment zákazky',
    'dennik.segment_rd':     'RD — rodinný dom',
    'dennik.segment_firma':  'FIRMA',
    'dennik.segment_hint':   'Zákazka nemá segment. Vyber — uloží sa do zákazky.',
    'dennik.segment_set':    'Segment zákazky uložený',
    'dennik.err.segment':    'Vyber segment zákazky (RD / FIRMA).',
    'dennik.room_opt':       'Byt / miestnosť (nepovinné)',
    // multi-user zámok zápisu (ústava 53.7)
    'dennik.locked_by':      'Zápis upravuje {meno} — zamknuté',
    'dennik.locked_hint':    'Počkaj kým druhý dokončí, alebo sa vráť späť.',
    // výzva pre Majstra — parťák ohlásil koniec etapy (ústava 4.A)
    'dennik.vyzva_label':    'parťák ohlásil koniec etapy',
    'dennik.vyzva_action':   'Over Kontrolným / Posledným zápisom',
  },
  // sq — albánčina (AI preklad zo sk, ústava sek. 6, 2026-06-16). Doladenie človekom môže prísť neskôr.
  sq: {
    'dennik.flat': 'Banesa',
    'dennik.rozsah': 'Shënimi vlen për',
    'dennik.rozsah.stavba': 'Për ndërtimin',
    'dennik.rozsah.byt': 'Për banesën',
    'dennik.rozsah.stavba_hint': 'I gjithë ndërtimi, objekti ose kati — pa banesë.',
    'dennik.rozsah.byt_hint': 'Një banesë e caktuar. Për banesë tjetër bëhet shënim i veçantë.',
    'dennik.byt_ph': 'Numri i banesës — p.sh. B3.12',
    'dennik.err.byt': 'Shëno numrin e banesës — pa të shënimi nuk ruhet.',
    'dennik.miestnost': 'Dhoma',
    'dennik.miestnost_opt': 'Dhoma (jo e detyrueshme)',
    'dennik.floor_ine': 'Tjetër…',
    'dennik.floor_ine_ph': 'Përshkrim i vet…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Suvatime',
    'preset.g.potery': 'Shtresa dyshemeje',
    'preset.g.malby': 'Lyerje',
    'preset.g.kontrola': 'Kontrolli i suvatuesit',
    'preset.g.pripravenost': 'Gatishmëria e kantierit',
    'preset.om.1': 'Përgatitja e nënshtresës',
    'preset.om.2': 'Vendosja e folieve dhe shiritave mbrojtës',
    'preset.om.3': 'Aplikimi i suvasë me gips në mure',
    'preset.om.4': 'Aplikimi i suvasë me gips në tavane',
    'preset.om.5': 'Aplikimi i suvasë gëlqere-çimento në mure',
    'preset.om.6': 'Aplikimi i suvasë gëlqere-çimento në tavane',
    'preset.om.7': 'Aplikimi i astarit',
    'preset.om.8': 'Vendosja e profileve këndore',
    'preset.om.9': 'Vendosja e profileve APU të dritareve',
    'preset.om.10': 'Montimi i skelës',
    'preset.om.11': 'Çmontimi i skelës',
    'preset.om.12': 'Pastrimi',
    'preset.om.13': 'Heqja e folieve dhe shiritave',
    'preset.po.1': 'Përgatitja e nënshtresës (shlifim, thithje pluhuri)',
    'preset.po.2': 'Astarimi i nënshtresës',
    'preset.po.3': 'Ngjitja e shiritit perimetral',
    'preset.po.4': 'Shtrimi i folies PE/ndarëse',
    'preset.po.5': 'Shtrimi i fugës së dilatimit të kornizës',
    'preset.po.6': 'Aplikimi i shtresës së çimentos',
    'preset.po.7': 'Aplikimi i anhidritit (MIXFLOOR)',
    'preset.po.8': 'Nivelimi me lazer',
    'preset.po.9': 'Shlifimi i shtresës',
    'preset.po.10': 'Prerja e fugave të dilatimit',
    'preset.ma.1': 'Maskimi (shirita, folie)',
    'preset.ma.2': 'Përgatitja e nënshtresës',
    'preset.ma.3': 'Astar + lyerje (shtresa 1)',
    'preset.ma.4': 'Lyerja e sipërme (dora 2)',
    'preset.ma.5': 'Lyerje e tonuar (RAL)',
    'preset.ma.6': 'Riparime suvaje',
    'preset.ma.7': 'Shlifimi i riparimeve',
    'preset.ma.8': 'Dorëzimi i punimeve',
    'preset.ko.1': 'pa defekte',
    'preset.ko.2': 'finiturë e keqe anë dritareje',
    'preset.ko.3': 'kënd i drejtë jashtë normës',
    'preset.ko.4': 'rrafshësia e mureve jashtë normës',
    'preset.ko.5': 'rrafshësi e keqe e cokolëve',
    'preset.ko.6': 'finiturë e keqe e mureve',
    'preset.ko.7': 'finiturë e keqe e tavaneve',
    'preset.ko.8': 'priza të suvatuara',
    'preset.ko.9': 'kabllo të papastruara',
    'preset.ko.10': 'dritare të papastruara',
    'preset.ko.11': 'pa pastruar',
    'preset.pr.1': 'dritare të pamontuara',
    'preset.pr.2': 'instalime hidraulike të papërfunduara',
    'preset.pr.3': 'instalime elektrike të papërfunduara',
    'preset.pr.4': 'mungojnë shiritat e dritareve',
    'preset.pr.5': 'shkumë e paprerë',
    'preset.pr.6': 'kabllo tavani të pangjitura',
    'preset.pr.7': 'rrafshësia e mureve jashtë normës',
    'preset.pr.8': 'kënde të drejta jashtë normës',
    'common.save':     'Ruaj',
    'common.cancel':   'Anulo',
    'common.back':     'Mbrapa',
    'common.search':   'Kërko',
    'common.add':      'Shto',
    'common.delete':   'Fshi',
    'common.edit':     'Ndrysho',
    'common.yes':      'Po',
    'common.no':       'Jo',
    'common.loading':  'Po ngarkohet…',
    'common.done':     'Gati',
    'common.confirm':  'Konfirmo',
    'common.close':    'Mbyll',
    'common.required': 'e detyrueshme',
    'common.saved':    'U ruajt',
    'common.error':    'Gabim',
    'common.retry':    'Provo përsëri',
    'mobile.tab.dennik':    'Ditari',
    'mobile.tab.blocky':    'Kuponët',
    'mobile.tab.vymery':    'Matjet',
    'mobile.tab.vozidla':   'Automjetet',
    'mobile.tab.pozicovna': 'Qiraja',
    'mobile.tab.dochadzka': 'Prezenca',
    'mobile.tab.asistent':  'Asistenti',
    'mobile.tab.uzivatelia': 'Përdoruesit',
    'mobile.logout':        'Dil',
    'mobile.module_soon':   'Moduli po përgatitet.',
    'dennik.new':              'Shënim i ri',
    'dennik.empty':            'Ende asnjë shënim.',
    'dennik.daily':            'Shënim ditor',
    'dennik.control':          'Shënim kontrolli',
    'dennik.project':          'Projekti',
    'dennik.date':             'Data',
    'dennik.ctype':            'Lloji i kontrollit',
    'dennik.weather':          'Moti',
    'dennik.workers':          'Numri i punëtorëve',
    'dennik.work':             'Përshkrimi i punëve',
    'dennik.work_ph':          'Çfarë u punua sot…',
    'dennik.stoppage':         'Ndërprerjet',
    'dennik.stoppage_h':       'Orët e ndërprerjes',
    'dennik.koniec_etapy':     'PO PËRFUNDOJ ETAPËN — KËRKOJ PAGESËN',
    'dennik.poter.title':        'Shtresa e dyshemesë (nëse ka)',
    'dennik.poter.material':     'Lloji i materialit',
    'dennik.poter.none':         '— pa zgjedhur —',
    'dennik.poter.m2':           'Sipërfaqja (m²)',
    'dennik.poter.m2_ph':        'p.sh. 85,5',
    'dennik.poter.thickness':    'Trashësia (mm)',
    'dennik.poter.spotreba': 'Konsumi i materialit',
    'dennik.poter.spotreba_ph': 'p.sh. 45 kg/m²',
    'dennik.poter.price': 'Çmimi (e vendos zyra)',
    'dennik.poter.price_ph': '€ / m²',
    'dennik.poter.note': 'Shënim',
    'dennik.poter.note_ph': 'p.sh. dilatacione, shtesa…',
    'dennik.poter.thickness_ph': 'p.sh. 60',
    'dennik.save_first':       'Ruaj shënimin',
    'dennik.photos':           'Foto',
    'dennik.photo_after_save': 'Foto mund të shtohet pas ruajtjes së shënimit.',
    'dennik.add_photo':        'Shto foto',
    'dennik.photo_ok':         'Foto u ngarkua',
    'dennik.photo_err':        'Foto nuk u ngarkua — provo përsëri',
    'dennik.err.project':      'Zgjidh projektin.',
    'dennik.err.desc':         'Plotëso përshkrimin e punëve.',
    'dennik.type.denny':       'Ditor',
    'dennik.type.prvy':        'I parë',
    'dennik.type.kontrolny':   'Kontrolli',
    'dennik.type.posledny':    'I fundit',
    'dennik.type.priebezny':   'I vazhdueshëm (i vjetër)',
    'dennik.weather.sucho':    'Thatë',
    'dennik.weather.zamracene':'Vranët',
    'dennik.weather.dazd':     'Shi',
    'dennik.weather.sneh':     'Borë',
    'dennik.weather.vietor':   'Erë',
    'dennik.weather.mraz':     'Ngricë',
    'dennik.sreason.nepripravenost': 'Mospërgatitje',
    'dennik.sreason.tech_porucha':   'Defekt teknik',
    'dennik.sreason.no_material':    'Mungon materiali',
    'dennik.sreason.teplota':        'Temperaturë e papërshtatshme',
    'dennik.sreason.neporiadok':     'Rrëmujë',
    'dennik.sreason.vlastny':        'Tjetër',
    'dennik.temp':            'Temperatura',
    'dennik.temp_load':       'Ngarko',
    'dennik.temp_ok':         'Temperatura u ngarkua',
    'dennik.temp_fail':       'Moti nuk u ngarkua',
    'dennik.temp_no_addr':    'Projekti nuk ka adresë — shkruaj temperaturën manualisht',
    'dennik.findings':        'Lloji i kontrollit / gjetjet',
    'dennik.object':          'Objekti',
    'dennik.floor':           'Kati',
    'dennik.room':            'Banesa / dhoma',
    'dennik.add_block':       'Shto përshkrim',
    'dennik.stoppage_by':     'Kush e shkaktoi ndërprerjen',
    'dennik.opatrenie':       'Masa e ruajtur',
    'dennik.opatr_co':        'Çfarë duhet bërë',
    'dennik.opatr_kto':       'Përgjegjësi',
    'dennik.handover':        'Marrja / dorëzimi',
    'dennik.taken':           'Marrë nga kontraktori',
    'dennik.given':           'Dorëzuar kontraktorit',
    'dennik.mark_done':       'Shëno dhomën si të kryer',
    'dennik.done_mark':       'Kryer',
    'dennik.segment':        'Segmenti i projektit',
    'dennik.segment_rd':     'RD — shtëpi familjare',
    'dennik.segment_firma':  'FIRMË',
    'dennik.segment_hint':   'Projekti nuk ka segment. Zgjidh — do të ruhet te projekti.',
    'dennik.segment_set':    'Segmenti i projektit u ruajt',
    'dennik.err.segment':    'Zgjidh segmentin e projektit (RD / FIRMË).',
    'dennik.room_opt':       'Banesa / dhoma (jo e detyrueshme)',
    'dennik.locked_by':      'Shënimin po e modifikon {meno} — i bllokuar',
    'dennik.locked_hint':    'Prit derisa tjetri të mbarojë, ose kthehu mbrapa.',
    'dennik.vyzva_label':    'kryepunëtori njoftoi fundin e etapës',
    'dennik.vyzva_action':   'Verifiko me shënim Kontrolli / të Fundit',
  },
  // uk — ukrajinčina (AI preklad zo sk, ústava sek. 6, 2026-06-16)
  uk: {
    'dennik.flat': 'Квартира',
    'dennik.miestnost': 'Приміщення',
    'dennik.miestnost_opt': 'Приміщення (необов\'язково)',
    'dennik.floor_ine': 'Інше…',
    'dennik.floor_ine_ph': 'Власний опис…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Штукатурки',
    'preset.g.potery': 'Стяжки',
    'preset.g.malby': 'Фарбування',
    'preset.g.kontrola': 'Контроль штукатура',
    'preset.g.pripravenost': 'Готовність об’єкта',
    'preset.om.1': 'Підготовка основи',
    'preset.om.2': 'Монтаж захисних плівок і стрічок',
    'preset.om.3': 'Нанесення гіпсової штукатурки на стіни',
    'preset.om.4': 'Нанесення гіпсової штукатурки на стелі',
    'preset.om.5': 'Нанесення вапняно-цементної штукатурки на стіни',
    'preset.om.6': 'Нанесення вапняно-цементної штукатурки на стелі',
    'preset.om.7': 'Нанесення ґрунтовки',
    'preset.om.8': 'Монтаж кутових профілів',
    'preset.om.9': 'Монтаж віконних APU-профілів',
    'preset.om.10': 'Монтаж риштування',
    'preset.om.11': 'Демонтаж риштування',
    'preset.om.12': 'Прибирання',
    'preset.om.13': 'Зняття плівок і стрічок',
    'preset.po.1': 'Підготовка основи (шліфування, знепилення)',
    'preset.po.2': 'Ґрунтування основи',
    'preset.po.3': 'Приклеювання демпферної стрічки',
    'preset.po.4': 'Укладання PE/розділювальної плівки',
    'preset.po.5': 'Влаштування рамного деформаційного шва',
    'preset.po.6': 'Укладання цементної стяжки',
    'preset.po.7': 'Заливання ангідриту (MIXFLOOR)',
    'preset.po.8': 'Вирівнювання лазером',
    'preset.po.9': 'Шліфування стяжки',
    'preset.po.10': 'Нарізання деформаційних швів',
    'preset.ma.1': 'Обклеювання (стрічки, плівки)',
    'preset.ma.2': 'Підготовка основи',
    'preset.ma.3': 'Ґрунтовка + фарбування (1-й шар)',
    'preset.ma.4': 'Фінішне фарбування (2-й шар)',
    'preset.ma.5': 'Тоноване фарбування (RAL)',
    'preset.ma.6': 'Ремонт штукатурки',
    'preset.ma.7': 'Шліфування ремонтних місць',
    'preset.ma.8': 'Здача робіт',
    'preset.ko.1': 'без дефектів',
    'preset.ko.2': 'поганий фініш відкосу',
    'preset.ko.3': 'прямий кут поза нормою',
    'preset.ko.4': 'рівність стін поза нормою',
    'preset.ko.5': 'погана рівність цоколів',
    'preset.ko.6': 'поганий фініш стін',
    'preset.ko.7': 'поганий фініш стель',
    'preset.ko.8': 'заштукатурені розетки',
    'preset.ko.9': 'неочищені кабелі',
    'preset.ko.10': 'неочищені вікна',
    'preset.ko.11': 'не прибрано',
    'preset.pr.1': 'невстановлені вікна',
    'preset.pr.2': 'незавершена сантехніка',
    'preset.pr.3': 'незавершена електрика',
    'preset.pr.4': 'відсутні віконні стрічки',
    'preset.pr.5': 'необрізана піна',
    'preset.pr.6': 'неприклеєні кабелі на стелях',
    'preset.pr.7': 'рівність стін поза нормою',
    'preset.pr.8': 'прямі кути поза нормою',
    'common.save':     'Зберегти',
    'common.cancel':   'Скасувати',
    'common.back':     'Назад',
    'common.search':   'Пошук',
    'common.add':      'Додати',
    'common.delete':   'Видалити',
    'common.edit':     'Редагувати',
    'common.yes':      'Так',
    'common.no':       'Ні',
    'common.loading':  'Завантаження…',
    'common.done':     'Готово',
    'common.confirm':  'Підтвердити',
    'common.close':    'Закрити',
    'common.required': "обов'язково",
    'common.saved':    'Збережено',
    'common.error':    'Помилка',
    'common.retry':    'Спробувати ще раз',
    'mobile.tab.dennik':    'Журнал',
    'mobile.tab.blocky':    'Чеки',
    'mobile.tab.vymery':    'Заміри',
    'mobile.tab.vozidla':   'Транспорт',
    'mobile.tab.pozicovna': 'Прокат',
    'mobile.tab.dochadzka': 'Відвідуваність',
    'mobile.tab.asistent':  'Асистент',
    'mobile.tab.uzivatelia': 'Користувачі',
    'mobile.logout':        'Вийти',
    'mobile.module_soon':   'Модуль готується.',
    'dennik.new':              'Новий запис',
    'dennik.empty':            'Поки що немає записів.',
    'dennik.daily':            'Щоденний запис',
    'dennik.control':          'Контрольний запис',
    'dennik.project':          'Замовлення',
    'dennik.date':             'Дата',
    'dennik.ctype':            'Тип перевірки',
    'dennik.weather':          'Погода',
    'dennik.workers':          'Кількість працівників',
    'dennik.work':             'Опис робіт',
    'dennik.rozsah': 'Запис стосується',
    'dennik.rozsah.stavba': 'До будови',
    'dennik.rozsah.byt': 'До квартири',
    'dennik.rozsah.stavba_hint': 'Уся будова, об’єкт або поверх — без квартири.',
    'dennik.rozsah.byt_hint': 'Одна конкретна квартира. На іншу квартиру — окремий запис.',
    'dennik.byt_ph': 'Номер квартири — напр. B3.12',
    'dennik.err.byt': 'Вкажи номер квартири — без нього запис не збережеться.',
    'dennik.work_ph':          'Що сьогодні робили…',
    'dennik.stoppage':         'Простої',
    'dennik.stoppage_h':       'Години простою',
    'dennik.koniec_etapy':     'ЗАВЕРШУЮ ЕТАП — ВИМАГАЮ ОПЛАТУ',
    'dennik.poter.title':        'Стяжка (якщо є)',
    'dennik.poter.material':     'Тип матеріалу',
    'dennik.poter.none':         '— не вказувати —',
    'dennik.poter.m2':           'Площа (m²)',
    'dennik.poter.m2_ph':        'напр. 85,5',
    'dennik.poter.thickness':    'Товщина (мм)',
    'dennik.poter.spotreba': 'Витрата матеріалу',
    'dennik.poter.spotreba_ph': 'напр. 45 кг/м²',
    'dennik.poter.price': 'Ціна (вводить офіс)',
    'dennik.poter.price_ph': '€ / м²',
    'dennik.poter.note': 'Примітка',
    'dennik.poter.note_ph': 'напр. деформ. шви, добавки…',
    'dennik.poter.thickness_ph': 'напр. 60',
    'dennik.save_first':       'Зберегти запис',
    'dennik.photos':           'Фото',
    'dennik.photo_after_save': 'Фото можна додати після збереження запису.',
    'dennik.add_photo':        'Додати фото',
    'dennik.photo_ok':         'Фото завантажено',
    'dennik.photo_err':        'Фото не завантажилось — спробуйте ще раз',
    'dennik.err.project':      'Виберіть замовлення.',
    'dennik.err.desc':         'Заповніть опис робіт.',
    'dennik.type.denny':       'Щоденний',
    'dennik.type.prvy':        'Перший',
    'dennik.type.kontrolny':   'Контрольний',
    'dennik.type.posledny':    'Останній',
    'dennik.type.priebezny':   'Поточний (старий)',
    'dennik.weather.sucho':    'Сухо',
    'dennik.weather.zamracene':'Хмарно',
    'dennik.weather.dazd':     'Дощ',
    'dennik.weather.sneh':     'Сніг',
    'dennik.weather.vietor':   'Вітер',
    'dennik.weather.mraz':     'Мороз',
    'dennik.sreason.nepripravenost': 'Непідготовленість',
    'dennik.sreason.tech_porucha':   'Тех. несправність',
    'dennik.sreason.no_material':    'Немає матеріалу',
    'dennik.sreason.teplota':        'Невідповідна температура',
    'dennik.sreason.neporiadok':     'Безлад',
    'dennik.sreason.vlastny':        'Інше',
    'dennik.temp':            'Температура',
    'dennik.temp_load':       'Завантажити',
    'dennik.temp_ok':         'Температуру завантажено',
    'dennik.temp_fail':       'Погоду не завантажено',
    'dennik.temp_no_addr':    'Замовлення не має адреси — введіть температуру вручну',
    'dennik.findings':        'Тип перевірки / висновки',
    'dennik.object':          "Об'єкт",
    'dennik.floor':           'Поверх',
    'dennik.room':            'Квартира / приміщення',
    'dennik.add_block':       'Додати опис',
    'dennik.stoppage_by':     'Хто спричинив простій',
    'dennik.opatrenie':       'Збережений захід',
    'dennik.opatr_co':        'Що потрібно зробити',
    'dennik.opatr_kto':       'Відповідальний',
    'dennik.handover':        'Приймання / передача',
    'dennik.taken':           'Прийнято від виконавця',
    'dennik.given':           'Передано виконавцю',
    'dennik.mark_done':       'Позначити приміщення готовим',
    'dennik.done_mark':       'Готово',
    'dennik.segment':        'Сегмент замовлення',
    'dennik.segment_rd':     'RD — приватний будинок',
    'dennik.segment_firma':  'ФІРМА',
    'dennik.segment_hint':   'Замовлення не має сегмента. Виберіть — збережеться в замовленні.',
    'dennik.segment_set':    'Сегмент замовлення збережено',
    'dennik.err.segment':    'Виберіть сегмент замовлення (RD / ФІРМА).',
    'dennik.room_opt':       'Квартира / приміщення (необов’язково)',
    'dennik.locked_by':      'Запис редагує {meno} — заблоковано',
    'dennik.locked_hint':    'Зачекайте, поки інший завершить, або поверніться назад.',
    'dennik.vyzva_label':    'бригадир повідомив про завершення етапу',
    'dennik.vyzva_action':   'Перевірте Контрольним / Останнім записом',
  },
  // pl — poľština (AI preklad zo sk, ústava sek. 6, 2026-06-16)
  pl: {
    'dennik.flat': 'Mieszkanie',
    'dennik.rozsah': 'Zakres zapisu',
    'dennik.rozsah.stavba': 'Do budowy',
    'dennik.rozsah.byt': 'Do mieszkania',
    'dennik.rozsah.stavba_hint': 'Cała budowa, obiekt lub piętro — bez mieszkania.',
    'dennik.rozsah.byt_hint': 'Jedno konkretne mieszkanie. Na kolejne mieszkanie osobny zapis.',
    'dennik.byt_ph': 'Numer mieszkania — np. B3.12',
    'dennik.err.byt': 'Podaj numer mieszkania — bez niego zapis się nie zapisze.',
    'dennik.miestnost': 'Pomieszczenie',
    'dennik.miestnost_opt': 'Pomieszczenie (opcjonalnie)',
    'dennik.floor_ine': 'Inne…',
    'dennik.floor_ine_ph': 'Własny opis…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Tynki',
    'preset.g.potery': 'Wylewki',
    'preset.g.malby': 'Malowanie',
    'preset.g.kontrola': 'Kontrola tynkarza',
    'preset.g.pripravenost': 'Gotowość budowy',
    'preset.om.1': 'Przygotowanie podłoża',
    'preset.om.2': 'Montaż folii i taśm ochronnych',
    'preset.om.3': 'Nakładanie tynku gipsowego na ściany',
    'preset.om.4': 'Nakładanie tynku gipsowego na sufity',
    'preset.om.5': 'Nakładanie tynku wapienno-cementowego na ściany',
    'preset.om.6': 'Nakładanie tynku wapienno-cementowego na sufity',
    'preset.om.7': 'Gruntowanie',
    'preset.om.8': 'Montaż profili narożnych',
    'preset.om.9': 'Montaż profili przyokiennych APU',
    'preset.om.10': 'Montaż rusztowania',
    'preset.om.11': 'Demontaż rusztowania',
    'preset.om.12': 'Sprzątanie',
    'preset.om.13': 'Usunięcie folii i taśm',
    'preset.po.1': 'Przygotowanie podłoża (szlifowanie, odkurzanie)',
    'preset.po.2': 'Gruntowanie podłoża',
    'preset.po.3': 'Klejenie taśmy brzegowej',
    'preset.po.4': 'Układanie folii PE/separacyjnej',
    'preset.po.5': 'Układanie dylatacji ramowej',
    'preset.po.6': 'Wykonanie wylewki cementowej',
    'preset.po.7': 'Wykonanie anhydrytu (MIXFLOOR)',
    'preset.po.8': 'Wyrównanie laserem',
    'preset.po.9': 'Szlifowanie wylewki',
    'preset.po.10': 'Nacinanie szczelin dylatacyjnych',
    'preset.ma.1': 'Oklejanie (taśmy, folie)',
    'preset.ma.2': 'Przygotowanie podłoża',
    'preset.ma.3': 'Gruntowanie + malowanie (1. warstwa)',
    'preset.ma.4': 'Malowanie nawierzchniowe (2. warstwa)',
    'preset.ma.5': 'Malowanie w kolorze (RAL)',
    'preset.ma.6': 'Naprawy tynków',
    'preset.ma.7': 'Szlifowanie napraw',
    'preset.ma.8': 'Przekazanie prac',
    'preset.ko.1': 'bez usterek',
    'preset.ko.2': 'złe wykończenie ościeża',
    'preset.ko.3': 'kąt prosty poza normą',
    'preset.ko.4': 'równość ścian poza normą',
    'preset.ko.5': 'zła równość cokołów',
    'preset.ko.6': 'złe wykończenie ścian',
    'preset.ko.7': 'złe wykończenie sufitów',
    'preset.ko.8': 'zatynkowane gniazdka',
    'preset.ko.9': 'nieoczyszczone kable',
    'preset.ko.10': 'nieoczyszczone okna',
    'preset.ko.11': 'nieposprzątane',
    'preset.pr.1': 'niezamontowane okna',
    'preset.pr.2': 'niedokończone instalacje sanitarne',
    'preset.pr.3': 'niedokończone instalacje elektryczne',
    'preset.pr.4': 'brak taśm okiennych',
    'preset.pr.5': 'nieobcięta piana',
    'preset.pr.6': 'nieprzyklejone kable sufitowe',
    'preset.pr.7': 'równość ścian poza normą',
    'preset.pr.8': 'kąty proste poza normą',
    'common.save':     'Zapisz',
    'common.cancel':   'Anuluj',
    'common.back':     'Wstecz',
    'common.search':   'Szukaj',
    'common.add':      'Dodaj',
    'common.delete':   'Usuń',
    'common.edit':     'Edytuj',
    'common.yes':      'Tak',
    'common.no':       'Nie',
    'common.loading':  'Ładowanie…',
    'common.done':     'Gotowe',
    'common.confirm':  'Potwierdź',
    'common.close':    'Zamknij',
    'common.required': 'wymagane',
    'common.saved':    'Zapisano',
    'common.error':    'Błąd',
    'common.retry':    'Spróbuj ponownie',
    'mobile.tab.dennik':    'Dziennik',
    'mobile.tab.blocky':    'Paragony',
    'mobile.tab.vymery':    'Pomiary',
    'mobile.tab.vozidla':   'Pojazdy',
    'mobile.tab.pozicovna': 'Wypożyczalnia',
    'mobile.tab.dochadzka': 'Obecność',
    'mobile.tab.asistent':  'Asystent',
    'mobile.tab.uzivatelia': 'Użytkownicy',
    'mobile.logout':        'Wyloguj',
    'mobile.module_soon':   'Moduł w przygotowaniu.',
    'dennik.new':              'Nowy wpis',
    'dennik.empty':            'Brak wpisów.',
    'dennik.daily':            'Wpis dzienny',
    'dennik.control':          'Wpis kontrolny',
    'dennik.project':          'Zlecenie',
    'dennik.date':             'Data',
    'dennik.ctype':            'Rodzaj kontroli',
    'dennik.weather':          'Pogoda',
    'dennik.workers':          'Liczba pracowników',
    'dennik.work':             'Opis prac',
    'dennik.work_ph':          'Co dziś robiono…',
    'dennik.stoppage':         'Przestoje',
    'dennik.stoppage_h':       'Godziny przestoju',
    'dennik.koniec_etapy':     'KOŃCZĘ ETAP — ŻĄDAM ZAPŁATY',
    'dennik.poter.title':        'Wylewka (jeśli dotyczy)',
    'dennik.poter.material':     'Rodzaj materiału',
    'dennik.poter.none':         '— nie podawać —',
    'dennik.poter.m2':           'Powierzchnia (m²)',
    'dennik.poter.m2_ph':        'np. 85,5',
    'dennik.poter.thickness':    'Grubość (mm)',
    'dennik.poter.spotreba': 'Zużycie materiału',
    'dennik.poter.spotreba_ph': 'np. 45 kg/m²',
    'dennik.poter.price': 'Cena (wprowadza biuro)',
    'dennik.poter.price_ph': '€ / m²',
    'dennik.poter.note': 'Uwaga',
    'dennik.poter.note_ph': 'np. dylatacje, dodatki…',
    'dennik.poter.thickness_ph': 'np. 60',
    'dennik.save_first':       'Zapisz wpis',
    'dennik.photos':           'Zdjęcia',
    'dennik.photo_after_save': 'Zdjęcie można dodać po zapisaniu wpisu.',
    'dennik.add_photo':        'Dodaj zdjęcie',
    'dennik.photo_ok':         'Zdjęcie wgrane',
    'dennik.photo_err':        'Zdjęcie nie zostało wgrane — spróbuj ponownie',
    'dennik.err.project':      'Wybierz zlecenie.',
    'dennik.err.desc':         'Uzupełnij opis prac.',
    'dennik.type.denny':       'Dzienny',
    'dennik.type.prvy':        'Pierwszy',
    'dennik.type.kontrolny':   'Kontrolny',
    'dennik.type.posledny':    'Ostatni',
    'dennik.type.priebezny':   'Bieżący (stary)',
    'dennik.weather.sucho':    'Sucho',
    'dennik.weather.zamracene':'Pochmurno',
    'dennik.weather.dazd':     'Deszcz',
    'dennik.weather.sneh':     'Śnieg',
    'dennik.weather.vietor':   'Wiatr',
    'dennik.weather.mraz':     'Mróz',
    'dennik.sreason.nepripravenost': 'Brak przygotowania',
    'dennik.sreason.tech_porucha':   'Awaria techn.',
    'dennik.sreason.no_material':    'Brak materiału',
    'dennik.sreason.teplota':        'Nieodpowiednia temperatura',
    'dennik.sreason.neporiadok':     'Bałagan',
    'dennik.sreason.vlastny':        'Inne',
    'dennik.temp':            'Temperatura',
    'dennik.temp_load':       'Wczytaj',
    'dennik.temp_ok':         'Temperatura wczytana',
    'dennik.temp_fail':       'Nie wczytano pogody',
    'dennik.temp_no_addr':    'Zlecenie nie ma adresu — wpisz temperaturę ręcznie',
    'dennik.findings':        'Rodzaj kontroli / ustalenia',
    'dennik.object':          'Obiekt',
    'dennik.floor':           'Piętro',
    'dennik.room':            'Mieszkanie / pomieszczenie',
    'dennik.add_block':       'Dodaj opis',
    'dennik.stoppage_by':     'Kto spowodował przestój',
    'dennik.opatrenie':       'Zapisany środek',
    'dennik.opatr_co':        'Co należy zrobić',
    'dennik.opatr_kto':       'Odpowiedzialny',
    'dennik.handover':        'Przejęcie / przekazanie',
    'dennik.taken':           'Przejęte od wykonawcy',
    'dennik.given':           'Przekazane wykonawcy',
    'dennik.mark_done':       'Oznacz pomieszczenie jako gotowe',
    'dennik.done_mark':       'Gotowe',
    'dennik.segment':        'Segment zlecenia',
    'dennik.segment_rd':     'RD — dom jednorodzinny',
    'dennik.segment_firma':  'FIRMA',
    'dennik.segment_hint':   'Zlecenie nie ma segmentu. Wybierz — zapisze się w zleceniu.',
    'dennik.segment_set':    'Segment zlecenia zapisany',
    'dennik.err.segment':    'Wybierz segment zlecenia (RD / FIRMA).',
    'dennik.room_opt':       'Mieszkanie / pomieszczenie (opcjonalnie)',
    'dennik.locked_by':      'Wpis edytuje {meno} — zablokowane',
    'dennik.locked_hint':    'Poczekaj, aż drugi skończy, lub wróć.',
    'dennik.vyzva_label':    'brygadzista zgłosił koniec etapu',
    'dennik.vyzva_action':   'Zweryfikuj wpisem Kontrolnym / Ostatnim',
  },
  // en — angličtina (AI preklad zo sk + overenie, ústava sek. 6, 2026-07-20)
  en: {
    'dennik.flat': 'Apartment',
    'dennik.rozsah': 'Entry scope',
    'dennik.rozsah.stavba': 'Site entry',
    'dennik.rozsah.byt': 'Apartment entry',
    'dennik.rozsah.stavba_hint': 'Whole site, building or floor — no apartment.',
    'dennik.rozsah.byt_hint': 'One specific apartment. Another apartment needs its own entry.',
    'dennik.byt_ph': 'Apartment number — e.g. B3.12',
    'dennik.err.byt': 'Enter the apartment number — the entry cannot be saved without it.',
    'dennik.miestnost': 'Room',
    'dennik.miestnost_opt': 'Room (optional)',
    'dennik.floor_ine': 'Other…',
    'dennik.floor_ine_ph': 'Custom description…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Plastering',
    'preset.g.potery': 'Screeds',
    'preset.g.malby': 'Painting',
    'preset.g.kontrola': 'Plasterer check',
    'preset.g.pripravenost': 'Site readiness',
    'preset.om.1': 'Substrate preparation',
    'preset.om.2': 'Installing protective film and tape',
    'preset.om.3': 'Applying gypsum plaster to walls',
    'preset.om.4': 'Applying gypsum plaster to ceilings',
    'preset.om.5': 'Applying lime-cement plaster to walls',
    'preset.om.6': 'Applying lime-cement plaster to ceilings',
    'preset.om.7': 'Applying primer',
    'preset.om.8': 'Installing corner beads',
    'preset.om.9': 'Installing window APU profiles',
    'preset.om.10': 'Scaffolding erection',
    'preset.om.11': 'Scaffolding dismantling',
    'preset.om.12': 'Cleanup',
    'preset.om.13': 'Removing film and tape',
    'preset.po.1': 'Substrate preparation (grinding, vacuuming)',
    'preset.po.2': 'Substrate priming',
    'preset.po.3': 'Installing perimeter edge strip',
    'preset.po.4': 'Laying PE/separation film',
    'preset.po.5': 'Installing frame expansion joints',
    'preset.po.6': 'Applying cement screed',
    'preset.po.7': 'Applying anhydrite (MIXFLOOR)',
    'preset.po.8': 'Laser leveling',
    'preset.po.9': 'Screed grinding',
    'preset.po.10': 'Cutting expansion joints',
    'preset.ma.1': 'Masking (tape, film)',
    'preset.ma.2': 'Substrate preparation',
    'preset.ma.3': 'Primer + painting (1st coat)',
    'preset.ma.4': 'Top coat (2nd coat)',
    'preset.ma.5': 'Tinted painting (RAL)',
    'preset.ma.6': 'Plaster repairs',
    'preset.ma.7': 'Sanding repairs',
    'preset.ma.8': 'Work handover',
    'preset.ko.1': 'no defects',
    'preset.ko.2': 'poor window reveal finish',
    'preset.ko.3': 'right angle out of tolerance',
    'preset.ko.4': 'wall flatness out of tolerance',
    'preset.ko.5': 'poor skirting flatness',
    'preset.ko.6': 'poor wall finish',
    'preset.ko.7': 'poor ceiling finish',
    'preset.ko.8': 'sockets plastered over',
    'preset.ko.9': 'cables not cleaned',
    'preset.ko.10': 'windows not cleaned',
    'preset.ko.11': 'not cleaned up',
    'preset.pr.1': 'windows not installed',
    'preset.pr.2': 'plumbing not finished',
    'preset.pr.3': 'electrical not finished',
    'preset.pr.4': 'window tapes missing',
    'preset.pr.5': 'foam not trimmed',
    'preset.pr.6': 'ceiling cables not fixed',
    'preset.pr.7': 'wall flatness out of tolerance',
    'preset.pr.8': 'right angles out of tolerance',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.back': 'Back',
    'common.search': 'Search',
    'common.add': 'Add',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.loading': 'Loading…',
    'common.done': 'Done',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.required': 'required',
    'common.saved': 'Saved',
    'common.error': 'Error',
    'common.retry': 'Retry',
    'mobile.tab.dennik': 'Log',
    'mobile.tab.blocky': 'Receipts',
    'mobile.tab.vymery': 'Measurements',
    'mobile.tab.vozidla': 'Vehicles',
    'mobile.tab.pozicovna': 'Rental',
    'mobile.tab.dochadzka': 'Attendance',
    'mobile.tab.asistent': 'Assistant',
    'mobile.tab.uzivatelia': 'Users',
    'mobile.logout': 'Log out',
    'mobile.module_soon': 'Module coming soon.',
    'dennik.new': 'New entry',
    'dennik.empty': 'No entries yet.',
    'dennik.daily': 'Daily entry',
    'dennik.control': 'Inspection entry',
    'dennik.project': 'Job',
    'dennik.date': 'Date',
    'dennik.ctype': 'Inspection type',
    'dennik.weather': 'Weather',
    'dennik.workers': 'Workers',
    'dennik.work': 'Work description',
    'dennik.work_ph': 'What was done today…',
    'dennik.stoppage': 'Downtime',
    'dennik.stoppage_h': 'Downtime hours',
    'dennik.koniec_etapy': 'FINISHING STAGE — REQUEST PAYMENT',
    'dennik.poter.title': 'Screed (if applicable)',
    'dennik.poter.material': 'Material type',
    'dennik.poter.none': '— not specified —',
    'dennik.poter.m2': 'Area (m²)',
    'dennik.poter.m2_ph': 'e.g. 85.5',
    'dennik.poter.thickness': 'Thickness (mm)',
    'dennik.poter.spotreba': 'Material usage',
    'dennik.poter.spotreba_ph': 'e.g. 45 kg/m²',
    'dennik.poter.price': 'Price (set by office)',
    'dennik.poter.price_ph': '€ / m²',
    'dennik.poter.note': 'Note',
    'dennik.poter.note_ph': 'e.g. expansion joints, extras…',
    'dennik.poter.thickness_ph': 'e.g. 60',
    'dennik.save_first': 'Save entry',
    'dennik.photos': 'Photos',
    'dennik.photo_after_save': 'Photos can be added after saving the entry.',
    'dennik.add_photo': 'Add photo',
    'dennik.photo_ok': 'Photo uploaded',
    'dennik.photo_err': 'Photo upload failed — try again',
    'dennik.err.project': 'Select a job.',
    'dennik.err.desc': 'Fill in work description.',
    'dennik.type.denny': 'Daily',
    'dennik.type.prvy': 'First',
    'dennik.type.kontrolny': 'Inspection',
    'dennik.type.posledny': 'Final',
    'dennik.type.priebezny': 'Interim (old)',
    'dennik.weather.sucho': 'Dry',
    'dennik.weather.zamracene': 'Overcast',
    'dennik.weather.dazd': 'Rain',
    'dennik.weather.sneh': 'Snow',
    'dennik.weather.vietor': 'Wind',
    'dennik.weather.mraz': 'Frost',
    'dennik.sreason.nepripravenost': 'Not ready',
    'dennik.sreason.tech_porucha': 'Tech fault',
    'dennik.sreason.no_material': 'No material',
    'dennik.sreason.teplota': 'Unsuitable temperature',
    'dennik.sreason.neporiadok': 'Mess',
    'dennik.sreason.vlastny': 'Custom',
    'dennik.temp': 'Temperature',
    'dennik.temp_load': 'Load',
    'dennik.temp_ok': 'Temperature loaded',
    'dennik.temp_fail': 'Weather failed to load',
    'dennik.temp_no_addr': 'Job has no address — enter temperature manually',
    'dennik.findings': 'Inspection type / findings',
    'dennik.object': 'Building',
    'dennik.floor': 'Floor',
    'dennik.room': 'Apartment / room',
    'dennik.add_block': 'Add description',
    'dennik.stoppage_by': 'Who caused downtime',
    'dennik.opatrenie': 'Corrective measure',
    'dennik.opatr_co': 'What needs to be done',
    'dennik.opatr_kto': 'Responsible',
    'dennik.handover': 'Takeover / handover',
    'dennik.taken': 'Taken over from contractor',
    'dennik.given': 'Handed over to contractor',
    'dennik.mark_done': 'Mark room done',
    'dennik.done_mark': 'Done',
    'dennik.segment': 'Job segment',
    'dennik.segment_rd': 'RD — detached house',
    'dennik.segment_firma': 'COMPANY',
    'dennik.segment_hint': 'Job has no segment. Select — it saves to the job.',
    'dennik.segment_set': 'Job segment saved',
    'dennik.err.segment': 'Select job segment (RD / COMPANY).',
    'dennik.room_opt': 'Apartment / room (optional)',
    'dennik.locked_by': '{meno} is editing the entry — locked',
    'dennik.locked_hint': 'Wait until the other person finishes, or go back.',
    'dennik.vyzva_label': 'team leader reported end of stage',
    'dennik.vyzva_action': 'Verify with Inspection / Final entry',
  },
  // ru — ruština (AI preklad zo sk + overenie, ústava sek. 6, 2026-07-20)
  ru: {
    'dennik.flat': 'Квартира',
    'dennik.miestnost': 'Помещение',
    'dennik.miestnost_opt': 'Помещение (необязательно)',
    'dennik.floor_ine': 'Другое…',
    'dennik.floor_ine_ph': 'Свой вариант…',
    // presety denníka — v jazyku používateľa (Mirko 20.7.)
    'preset.g.omietky': 'Штукатурка',
    'preset.g.potery': 'Стяжка',
    'preset.g.malby': 'Покраска',
    'preset.g.kontrola': 'Контроль штукатура',
    'preset.g.pripravenost': 'Готовность объекта',
    'preset.om.1': 'Подготовка основания',
    'preset.om.2': 'Монтаж защитных плёнок и лент',
    'preset.om.3': 'Нанесение гипсовой штукатурки на стены',
    'preset.om.4': 'Нанесение гипсовой штукатурки на потолки',
    'preset.om.5': 'Нанесение известково-цементной штукатурки на стены',
    'preset.om.6': 'Нанесение известково-цементной штукатурки на потолки',
    'preset.om.7': 'Нанесение грунтовки',
    'preset.om.8': 'Монтаж угловых профилей',
    'preset.om.9': 'Монтаж оконных APU-профилей',
    'preset.om.10': 'Монтаж лесов',
    'preset.om.11': 'Демонтаж лесов',
    'preset.om.12': 'Уборка',
    'preset.om.13': 'Снятие плёнок и лент',
    'preset.po.1': 'Подготовка основания (шлифовка, обеспыливание)',
    'preset.po.2': 'Грунтовка основания',
    'preset.po.3': 'Приклейка демпферной ленты',
    'preset.po.4': 'Укладка PE/разделительной плёнки',
    'preset.po.5': 'Устройство рамного деформационного шва',
    'preset.po.6': 'Заливка цементной стяжки',
    'preset.po.7': 'Заливка ангидрита (MIXFLOOR)',
    'preset.po.8': 'Выравнивание по лазеру',
    'preset.po.9': 'Шлифовка стяжки',
    'preset.po.10': 'Нарезка деформационных швов',
    'preset.ma.1': 'Оклейка (ленты, плёнки)',
    'preset.ma.2': 'Подготовка основания',
    'preset.ma.3': 'Грунтовка + покраска (1-й слой)',
    'preset.ma.4': 'Финишная покраска (2-й слой)',
    'preset.ma.5': 'Колерованная покраска (RAL)',
    'preset.ma.6': 'Ремонт штукатурки',
    'preset.ma.7': 'Шлифовка ремонтных мест',
    'preset.ma.8': 'Сдача работ',
    'preset.ko.1': 'без дефектов',
    'preset.ko.2': 'плохой финиш откоса',
    'preset.ko.3': 'прямой угол вне нормы',
    'preset.ko.4': 'ровность стен вне нормы',
    'preset.ko.5': 'плохая ровность цоколей',
    'preset.ko.6': 'плохой финиш стен',
    'preset.ko.7': 'плохой финиш потолков',
    'preset.ko.8': 'заштукатуренные розетки',
    'preset.ko.9': 'не очищены кабели',
    'preset.ko.10': 'не очищены окна',
    'preset.ko.11': 'не убрано',
    'preset.pr.1': 'не установлены окна',
    'preset.pr.2': 'не закончена сантехника',
    'preset.pr.3': 'не закончена электрика',
    'preset.pr.4': 'нет оконных лент',
    'preset.pr.5': 'не обрезана пена',
    'preset.pr.6': 'не приклеены кабели на потолках',
    'preset.pr.7': 'ровность стен вне нормы',
    'preset.pr.8': 'прямые углы вне нормы',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.back': 'Назад',
    'common.search': 'Поиск',
    'common.add': 'Добавить',
    'common.delete': 'Удалить',
    'common.edit': 'Изменить',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'common.loading': 'Загрузка…',
    'common.done': 'Готово',
    'common.confirm': 'Подтвердить',
    'common.close': 'Закрыть',
    'common.required': 'обязательно',
    'common.saved': 'Сохранено',
    'common.error': 'Ошибка',
    'common.retry': 'Повторить',
    'mobile.tab.dennik': 'Журнал',
    'mobile.tab.blocky': 'Чеки',
    'mobile.tab.vymery': 'Обмеры',
    'mobile.tab.vozidla': 'Транспорт',
    'mobile.tab.pozicovna': 'Прокат',
    'mobile.tab.dochadzka': 'Табель',
    'mobile.tab.asistent': 'Ассистент',
    'mobile.tab.uzivatelia': 'Пользователи',
    'mobile.logout': 'Выйти',
    'mobile.module_soon': 'Модуль в разработке.',
    'dennik.new': 'Новая запись',
    'dennik.empty': 'Пока нет записей.',
    'dennik.daily': 'Дневная запись',
    'dennik.control': 'Контрольная запись',
    'dennik.project': 'Заказ',
    'dennik.date': 'Дата',
    'dennik.ctype': 'Тип проверки',
    'dennik.weather': 'Погода',
    'dennik.workers': 'Кол-во рабочих',
    'dennik.work': 'Описание работ',
    'dennik.rozsah': 'Запись относится к',
    'dennik.rozsah.stavba': 'К стройке',
    'dennik.rozsah.byt': 'К квартире',
    'dennik.rozsah.stavba_hint': 'Вся стройка, объект или этаж — без квартиры.',
    'dennik.rozsah.byt_hint': 'Одна конкретная квартира. На другую квартиру — отдельная запись.',
    'dennik.byt_ph': 'Номер квартиры — напр. B3.12',
    'dennik.err.byt': 'Укажите номер квартиры — без него запись не сохранится.',
    'dennik.work_ph': 'Что делали сегодня…',
    'dennik.stoppage': 'Простои',
    'dennik.stoppage_h': 'Часы простоя',
    'dennik.koniec_etapy': 'ЗАВЕРШАЮ ЭТАП — ТРЕБУЮ ОПЛАТУ',
    'dennik.poter.title': 'Стяжка (если применимо)',
    'dennik.poter.material': 'Тип материала',
    'dennik.poter.none': '— не указывать —',
    'dennik.poter.m2': 'Площадь (m²)',
    'dennik.poter.m2_ph': 'напр. 85,5',
    'dennik.poter.thickness': 'Толщина (mm)',
    'dennik.poter.spotreba': 'Расход материала',
    'dennik.poter.spotreba_ph': 'напр. 45 kg/m²',
    'dennik.poter.price': 'Цена (вводит офис)',
    'dennik.poter.price_ph': '€ / m²',
    'dennik.poter.note': 'Примечание',
    'dennik.poter.note_ph': 'напр. деформационные швы, добавки…',
    'dennik.poter.thickness_ph': 'напр. 60',
    'dennik.save_first': 'Сохранить запись',
    'dennik.photos': 'Фото',
    'dennik.photo_after_save': 'Фото можно добавить после сохранения записи.',
    'dennik.add_photo': 'Добавить фото',
    'dennik.photo_ok': 'Фото загружено',
    'dennik.photo_err': 'Фото не загрузилось — повтори',
    'dennik.err.project': 'Выбери заказ.',
    'dennik.err.desc': 'Заполни описание работ.',
    'dennik.type.denny': 'Дневной',
    'dennik.type.prvy': 'Первый',
    'dennik.type.kontrolny': 'Контрольный',
    'dennik.type.posledny': 'Последний',
    'dennik.type.priebezny': 'Текущий (старый)',
    'dennik.weather.sucho': 'Сухо',
    'dennik.weather.zamracene': 'Облачно',
    'dennik.weather.dazd': 'Дождь',
    'dennik.weather.sneh': 'Снег',
    'dennik.weather.vietor': 'Ветер',
    'dennik.weather.mraz': 'Мороз',
    'dennik.sreason.nepripravenost': 'Неготовность',
    'dennik.sreason.tech_porucha': 'Тех. поломка',
    'dennik.sreason.no_material': 'Нет материала',
    'dennik.sreason.teplota': 'Неподходящая температура',
    'dennik.sreason.neporiadok': 'Беспорядок',
    'dennik.sreason.vlastny': 'Другое',
    'dennik.temp': 'Температура',
    'dennik.temp_load': 'Загрузить',
    'dennik.temp_ok': 'Температура загружена',
    'dennik.temp_fail': 'Погода не загрузилась',
    'dennik.temp_no_addr': 'У заказа нет адреса — введи температуру вручную',
    'dennik.findings': 'Тип проверки / замечания',
    'dennik.object': 'Объект',
    'dennik.floor': 'Этаж',
    'dennik.room': 'Квартира / помещение',
    'dennik.add_block': 'Добавить описание',
    'dennik.stoppage_by': 'Кто виновник простоя',
    'dennik.opatrenie': 'Назначенная мера',
    'dennik.opatr_co': 'Что нужно сделать',
    'dennik.opatr_kto': 'Ответственный',
    'dennik.handover': 'Приёмка / передача',
    'dennik.taken': 'Принято от подрядчика',
    'dennik.given': 'Передано подрядчику',
    'dennik.mark_done': 'Отметить помещение готовым',
    'dennik.done_mark': 'Готово',
    'dennik.segment': 'Сегмент заказа',
    'dennik.segment_rd': 'RD — частный дом',
    'dennik.segment_firma': 'КОМПАНИЯ',
    'dennik.segment_hint': 'У заказа нет сегмента. Выбери — сохранится в заказ.',
    'dennik.segment_set': 'Сегмент заказа сохранён',
    'dennik.err.segment': 'Выбери сегмент заказа (RD / КОМПАНИЯ).',
    'dennik.room_opt': 'Квартира / помещение (необязательно)',
    'dennik.locked_by': 'Запись редактирует {meno} — заблокировано',
    'dennik.locked_hint': 'Подожди, пока второй закончит, или вернись назад.',
    'dennik.vyzva_label': 'бригадир объявил конец этапа',
    'dennik.vyzva_action': 'Проверь Контрольной / Последней записью',
  },
}

// ── getLang — jazyk používateľa, s fallbackom na sk ──────────────────
export function getLang(user) {
  const lc = (user && user.language_code ? String(user.language_code) : '').toLowerCase()
  return STR[lc] ? lc : FALLBACK
}

// ── translate(lang, key, vars) — preklad; fallback: jazyk → sk → kľúč ──
// vars: { meno:'Jano' } nahradí {meno} v texte.
export function translate(lang, key, vars) {
  const dict = STR[lang] || STR[FALLBACK] || {}
  let s = dict[key]
  if (s === undefined) s = (STR[FALLBACK] || {})[key]
  if (s === undefined) return key                 // chýbajúci kľúč = viditeľný
  if (vars) {
    for (const k in vars) s = s.split('{' + k + '}').join(String(vars[k]))
  }
  return s
}

// ── Dynamický auto-jazyk (ústava 264): pri logine stiahni svoj jazyk z backendu ──
// Statické STR (sk/sq/uk/pl) = okamžitý fallback. Backend dogeneruje hocijaký jazyk cez Claude.
let _ver = 0
const _subs = new Set()
const _synced = new Set()
function _bump() { _ver++; _subs.forEach(f => { try { f(_ver) } catch (_) {} }) }

export async function syncLang(user) {
  const lc = (user && user.language_code ? String(user.language_code) : 'sk').toLowerCase()
  try {
    const tok = localStorage.getItem('kamir_token') || ''
    if (!_synced.has('__seed')) {
      _synced.add('__seed')
      fetch('/api/i18n/source', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok }, body: JSON.stringify({ dict: STR.sk }) }).catch(() => {})
    }
    if (!lc || lc === 'sk' || _synced.has(lc)) return
    _synced.add(lc)
    const r = await fetch('/api/i18n/' + encodeURIComponent(lc), { headers: { Authorization: 'Bearer ' + tok } })
    if (!r.ok) return
    const d = await r.json()
    if (d && d.dict && Object.keys(d.dict).length) { STR[lc] = Object.assign({}, STR[lc] || {}, d.dict); _bump() }
  } catch (_) {}
}

// ── useT — hook: vráti t(key, vars) viazané na jazyk prihláseného usera ──
//   const t = useT();  ...  t('common.save')
export function useT() {
  const { user } = useAuth()
  const [, setV] = useState(_ver)
  useEffect(() => { const f = v => setV(v); _subs.add(f); syncLang(user); return () => { _subs.delete(f) } }, [user && user.language_code])
  const lang = getLang(user)
  return useMemo(() => (key, vars) => translate(lang, key, vars), [lang, _ver])
}

export default useT
